module.exports = __webpack_public_path__ + "img/tag_hand.bae8dbc3.svg";